import { render, staticRenderFns } from "./AccountSwitcherModal.vue?vue&type=template&id=7b047ed1&scoped=true"
import script from "./AccountSwitcherModal.vue?vue&type=script&lang=js"
export * from "./AccountSwitcherModal.vue?vue&type=script&lang=js"
import style0 from "./AccountSwitcherModal.vue?vue&type=style&index=0&id=7b047ed1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b047ed1",
  null
  
)

export default component.exports